<template>
  <div style="position:relative;background-color:#131625;overflow: hidden;height: 100%">
    <div id="tv_chart_container">
      <KLine :self-item="selfItem" :is-long="true" :select-item="selectItem" :time="time" :button-index="buttonIndex" :coin-digital-num="selectItem.coinDigitalNum" :quantity-num="selectItem.quantityNum" :unit-numeral="selectItem.unitNumeral" @changefs="changefs" />
    </div>
    <div v-show="isFenshi" id="line_chart" :class="isClose?'line_chart_long':''"></div>
  </div>
</template>

<script>
/*global hqProtocol hqWs*/
import { mapGetters } from 'vuex'
import echartline from '../../../assets/js/echartline/k-line.js'
import KLine from './Kline.vue'
import * as echarts from 'echarts'
export default {
  name: 'QuotationLineCC',
  components: {
    KLine
  },
  props: ['TransCCDefaultTVStyle'],
  data() {
    return {
      isClose: true,
      isTradingViewReady: true,
      LINETimeout: null,
      defaultTVStyle: {
        time: 'M',
        isFenshi: true,
        buttonid: 0
      },
      isFenshi: true,

      LASTHIS: null,
      // 分时
      mChart: null,
      dataZoom: {
        startValue: null,
        endValue: null
      },
      mDateNum: 5, // 配置最多可见多少历史
      time: 20003, // k线周期 默认3分钟
      buttonIndex: 0
    }
  },
  computed: {
    /* eslint-disable vue/no-side-effects-in-computed-properties */
    ...mapGetters(['m_data', 'CommodityHighLowGetter']),
    item() {
      const item = this.$store.state.hqData.item?.symbol
      if (item) {
        return this.$store.state.hqData.item.symbol
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol
        } else {
          return '--'
        }
      }
    },
    selectItem() {
      const item = this.$store.state.hqData.item
      if (item?.symbolId) {
        return item
      } else if (this.$store.state.hqData.marketDetails.length > 0) { // 第一次进入取第1项(处理小数位)
        return this.$store.state.hqData.marketDetails[0]
      } else {
        return {
          close: 0.00,
          quotechangeColor: 'white',
          quotechange: 0.00,
          high: 0,
          low: 0,
          amount: 0,
          symbolId: '--',
          clearPrice: 0,
          numStr: /^(\d+)\.(\d{0,2}).*$/,
          coinDigitalNum: 2,
          quantityNum: 2 // 数量
        }
      }
    },
    symbol() {
      const item = this.$store.state.hqData.item?.symbolId
      if (item) {
        return this.$store.state.hqData.item.symbolId
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    selfItem() {
      const item = this.$store.state.hqData.item?.symbolId
      if (item) {
        return this.$store.state.hqData.item
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0]
        } else {
          return null
        }
      }
    },
    nowClosePrice() {
      return Number(this.selectItem.close).toFixed(this.selectItem.coinDigitalNum)
    }
  },
  watch: {
    m_data: {
      handler(v, ov) {
        if (v) {
          this.mDateNum = v?.timeFlag
        }
        this.$nextTick(() => {
          this.mlineChange()
        })
      },
      deep: true
    },
    async selfItem(val, oldVal) {
      if (this.mChart) { // 添加加载中提示
        if (!oldVal || (val.symbolId !== oldVal.symbolId)) {
          this.mChart.showLoading({
            text: '数据正在加载...',
            textStyle: { fontSize: 30, color: '#444' },
            effectOption: { backgroundColor: 'rgba(0, 0, 0, 0)' }
          })
          // this.chartloading = true // 添加加载中提示
        }
      }
      if (!oldVal && val && this.isTradingViewReady) {
        this.change(val.symbolId)
      } else if (val && this.isTradingViewReady && val.symbolId !== oldVal.symbolId) {
        this.change(val.symbolId)
      }
    },
    CommodityHighLowGetter: {
      handler(v, ov) {
        this.$nextTick(() => {
          this.mlineChange()
        })
      },
      deep: true
    },
    nowClosePrice(val, oldVal) {
      document.title = val + ' ' + this.item + ' ' + window.g.APP_TITLE_CLICK
    }
  },
  beforeCreate() {
    this.$store.commit('setMData', {
      data: [],
      yestclose: ''
    })
  },
  created() {
  },
  mounted: async function() {
    if (this.TransCCDefaultTVStyle) {
      this.defaultTVStyle = this.TransCCDefaultTVStyle
      this.time = this.TransCCDefaultTVStyle.time
      this.isFenshi = this.TransCCDefaultTVStyle.isFenshi
      this.buttonIndex = this.TransCCDefaultTVStyle.buttonid
    }
    this.initLine()
  },
  destroyed: function() {
    this.destroyChart()
    window.removeEventListener('resize', this.changeWindow)
    if (this.LINETimeout) {
      clearTimeout(this.LINETimeout)
      this.LINETimeout = null
    }
    document.title = window.g.APP_TITLE_ALL
    // 取消分时订阅
    hqProtocol.param_unsubscribe.contractIds = [hqProtocol.param_currencytimeline.contractId]
    hqWs.send(hqProtocol.param_unsubscribe)

    hqProtocol.param_currencytimeline.contractId = null
  },
  methods: {
    changefs(val, klineitem, index) {
      this.isFenshi = val
      this.time = klineitem.ID
      // 记录按钮点击信息
      this.defaultTVStyle = {
        time: this.time,
        isFenshi: val,
        buttonid: index
      }
      this.$emit('setDefaultTVStyle', this.defaultTVStyle)
    },
    initLine() {
      if (this.LINETimeout) {
        clearTimeout(this.LINETimeout)
        this.LINETimeout = null
      }
      const that = this
      if (!this.symbol || this.symbol == '--' || this.symbol.length == 0) {
        this.LINETimeout = setTimeout(() => {
          that.initLine()
        }, 1000)
        return
      }

      // 通过ws请求m_data
      hqProtocol.param_currencytimeline.contractId = this.symbol
      hqWs.send(hqProtocol.param_currencytimeline)

      this.changeChart()
    },
    // 创建分时图表
    changeChart() {
      const mdata = this.m_data
      let startValue = 0
      const endValue = mdata.data.length - 1
      mdata.data.map(v => {
        if (v[5] === '0') {
          startValue++
        }
      })
      this.dataZoom.startValue = startValue
      this.dataZoom.endValue = endValue
      // 创建分时数据
      this.mChart = echarts.init(document.getElementById('line_chart'))
      this.mChart.setOption(
        echartline.initMOption(
          mdata,
          'dd',
          null,
          Number(this.selectItem.coinDigitalNum),
          Number(this.selectItem.quantityNum),
          this.dataZoom,
          null,
          this.changeDataWithType,
          this.CommodityHighLowGetter.low,
          this.CommodityHighLowGetter.high
        )
      )
      this.mChart.on('datazoom', params => {
        const opt = this.mChart.getOption()
        // 记录起始日期
        this.dataZoom.startValue = opt.dataZoom[0].startValue
        this.dataZoom.endValue = opt.dataZoom[0].endValue
      })
      window.addEventListener('resize', this.changeWindow)
    },
    changeDataWithType(t) {
      switch (t) {
        case 'lastDay':
          hqProtocol.param_currencytimeline.timeFlag = hqProtocol.param_currencytimeline.timeFlag + 1
          if (hqProtocol.param_currencytimeline.timeFlag > this.mDateNum) {
            hqProtocol.param_currencytimeline.timeFlag = this.mDateNum
          }
          hqWs.send(hqProtocol.param_currencytimeline)
          break
        case 'nextDay':
          hqProtocol.param_currencytimeline.timeFlag = hqProtocol.param_currencytimeline.timeFlag - 1
          if (hqProtocol.param_currencytimeline.timeFlag < 0) {
            hqProtocol.param_currencytimeline.timeFlag = 0
          }
          hqWs.send(hqProtocol.param_currencytimeline)
          break
        case 'today':
          hqProtocol.param_currencytimeline.timeFlag = 0
          hqWs.send(hqProtocol.param_currencytimeline)
          break
        default:
          break
      }
    },
    // ws更新分时
    mlineChange() {
      const that = this
      const mdata = this.m_data
      that.mChart.setOption(
        echartline.initMOption(
          mdata,
          'dd',
          null,
          Number(this.selectItem.coinDigitalNum),
          Number(this.selectItem.quantityNum),
          that.dataZoom,
          null,
          this.changeDataWithType,
          this.CommodityHighLowGetter.low,
          this.CommodityHighLowGetter.high
        )
      )
      if (this.mChart) { // 添加加载中提示
        this.mChart.hideLoading()
      }
    },
    changeWindow() {
      if (this.isFenshi) {
        this.mChart.resize()
      }
    },
    // ws 更换商品
    lineChange() {
      hqProtocol.param_currencytimeline.contractId = this.symbol
      hqWs.send(hqProtocol.param_currencytimeline)
    },
    change(symbol) {
      // 更换商品
      // TODO 对接 k线
      // 分时
      if (this.mChart && symbol != '--') {
        this.lineChange()
      }
    },
    destroyChart() {
      if (this.mChart) {
        this.mChart.clear()
        this.mChart.dispose()
        this.mChart = null
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.topView, .topTitleView{
  height: 40px;
  background-color: #111217;
}
.topView span {
  display: inline-block;
  height: 40px;
  line-height: 40px;
}
.topView :nth-child(1) {
  margin-left: 20px;
  font-size: 16px;
  color:#B0B8DB;
  /* font-weight: bolder; */
}
.currencyBi{
   display: inline-block;
   position: relative;
    top: -9px;
    left: 15px;
  span{
    font-size:16px;
  }
}

.topTitleView .wrapz{
   display: inline-block;
  margin-left: 20px;
    text-align: center;
    line-height: 20px;
    width:60px;
    .graycolor{
      color:#7085ac;
    }
    p{
      color:#b0b8db;
    }
}
.topView :nth-child(2) {
  margin-left: 30px;
}
.topView :nth-child(3) {
  color: rgb(236, 72, 91);
}
.topView :nth-child(4) {
  margin-left: 30px;
}
.topView :nth-child(5) {
  margin-left: 30px;
}
.topView :nth-child(6) {
  margin-left: 30px;
}
.topView :nth-child(7) {
  display: inline-block;
  position: absolute;
  top: 5px;
  right: 5px;
}
#tv_chart_container {
  background-color: #131625;
  z-index: 1;
  height: 100%;
}
#line_chart {
  position: absolute;
  top: 37px;
  right: 0;
  left: 57px;
  bottom: 0;
  z-index: 2;
  background: #000;
}
.line_chart_long{
  left: 0px !important
}
// #tv_chart_container_loading {
//   position: absolute;
//   height: 50px;
//   width: 100%;
//   height: 895px;
//   z-index: 2;
//   background-color:#131625;
// }
// #tv_chart_container_loading .loader {
//   display: inline-block;
//   width: 100px;
//   height: 100px;
//   margin: 200px 45%;
// }
svg path,
svg rect {
  fill: rgb(185, 190, 190);
}

@media screen and(max-width: 1533px) {
  .topTitleView{
    height: 90px;
  }
  #tv_chart_container{
    // height: 410px;
  }
}
</style>
